<template>
  <!-- 报考指南 -->
  <el-button-group>
    <el-button type="primary" size="large" @click="addFnc('', $event)"
      ><el-icon><Plus /></el-icon>添加</el-button
    >
  </el-button-group>

  <!-- 表格组件 -->
  <TableList
    componentTableId="ExaminationGuide"
    @update-list="updateList"
    excelName="报考指南"
    :table-data="tableData"
    :header-data="headerData"
    :table-height="tableMaxHeight"
    :loading="loading"
    :loading-text="loadingText"
    :empty-text="emptyText"
    @editFnc="editFnc"
    @deleteFnc="deleteFnc"
    @searchFnc="searchFnc"
    @openContent="openContent"
  >
  <template #operationCustom="scope">
      <el-button type="primary" @click="editFnc(scope.scope)" plain>编辑</el-button>
      <el-button type="danger" @click="deleteFnc(scope.scope)" plain v-if="isDelect">删除</el-button>
    </template>
  </TableList>
  <!-- 底部工具 -->
  <Pagination
    :pagination="pagination"
    :is-loading="loading"
    @change-pagination="changePagination"
  >
  </Pagination>
  <!-- 添加编辑 报考指南 -->
  <el-dialog
    class="dialogNoPadding"
    :close-on-click-modal="false"
    v-model="addEditVisible"
    :title="dialogTitle"
    width="800px"
     draggable
            destroy-on-close
  >
    <AddExaminationGuide
      v-if="addEditVisible"
      :edit-id="editId"
      :category-sel="majorCategorySel"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddExaminationGuide>
  </el-dialog>
  <!-- 查看详情 弹窗 -->
  <el-dialog v-model="contentVisible" :title="contentdialogTitle" width="1000px"  draggable
            destroy-on-close>
    <div  class="contentDialog"
      v-html="contentDetails"
      v-if="contentVisible"
    ></div>
  </el-dialog>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
import Pagination from "components/Pagination.vue";
import { reactive, onMounted, toRefs, ref, toRaw,h,computed } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus } from "common/utils";
import constGlobal from "common/global.js";
import { getEntryGuideList, delEntryGuide } from "network/examinationGuide.js";
import AddExaminationGuide from "views/examinationGuide/AddExaminationGuide.vue";
import store from "../../store/index";

export default {
  name: "ExaminationGuide",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    Pagination,
    AddExaminationGuide,
  },
  watch:{
    contentDetails:{
      handler(val){
        let html = val;
         try {
          html = val;
        } catch (e) {
         html = val;
        }
      }
    }
  },
  setup() {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      roleId:computed(() => store.state.AdminCache.roleId || sessionStorage.getItem("AdminCache").roleId),
      configRoleId:computed(() => store.state.AdminCache.configRoleId || sessionStorage.getItem("AdminCache").configRoleId),
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      //表格数据
      tableData: [],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        },{
          label: "名称",
          prop: "title",
          minwidth: "200",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
        },
        {
          label: "所属类别",
          prop: "categoryName",
          minwidth: "200",
          align: "center",
          noSetText: "未设置",
          type: "SelectSearch",
          selectOptions: [],
         
        },
        {
          label: "排序值",
          prop: "orderIndex",
          minwidth: "200",
          align: "center",
          noSetText: "未设置"
        },
        {
          label: "描述",
          prop: "description",
          width: "200",
          align: "center",
          noSetText: "未设置",
          isToMoreContents: true,
        },
        {
          label: "操作",
          prop: "operation",
          width: "200",
          align: "center",
          fixed: "right",
          operation: true,
          edit: true,
          delete: true,
          custom:true,
        },
      ],
      //筛选项
      search: {
        title: "", //筛选 名称
        category: "", //筛选 类别
      },
      dialogTitle: "添加",
      addEditVisible: false, //添加编辑弹窗
      editId: 0, //是否是编辑
      contentdialogTitle: "",
      contentVisible: false, //内容弹窗
      contentDetails: "", //内容
    });

    //挂载后调用函数获取项目数据
    onMounted(() => {
       data.headerData.map((item) => {
        if (item.prop == "categoryName") {
          item.selectOptions = constGlobal.categoryList;
        }
      });
        getListData(); //请求列表数据
    });

    // 获取列表
    const getListData = () => {
      const obj = {
        title: data.search.title || null,
        category: data.search.category || null,
        pageIndex: data.pagination.currentPage,
        pageSize: data.pagination.pageSize,
      };
      getEntryGuideList(obj)
        .then((result) => {
          
          if (result && result.code == 1) {
            data.loading = false;
            data.tableData = result.data;
            data.pagination.total = result.totalCount;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "title") {
        data.search.title = val.value;
      }
      if (val.prop && val.prop == "categoryName") {
        data.search.category = val.value;
      }
      data.pagination.currentPage = 1;
      getListData();
    };

    //更新列表 区别于搜索要请求第一页
    const updateList = () => {
      getListData();
    };

    // 添加
    const addFnc = (row, e) => {
      // 强制移除按钮焦点
      lostFocus(e);
      data.addEditVisible = true;
      data.dialogTitle = "添加报考指南";
      data.editId = 0;
    };

    // 编辑
    const editFnc = (obj) => {
      data.addEditVisible = true;
      data.dialogTitle = `编辑【${obj.title}】`;
      data.editId = obj.id;
    };

    // 删除
    const deleteFnc = (obj) => {
         ElMessageBox({
        title: "删除",
        message: h("p", null, [
          h("span", null, "是否删除【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px;" },
            `${obj.title}`
          ),
          h("span", null, "】？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true
            instance.confirmButtonText = "确认中"
            // 删除接口
            delEntryGuide(obj.id)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                ElMessage.success(result.message);
                updateList();
              } else {
                done();
                ElMessage.error(result.message);
              }
            })
            .catch((err) => {
              done();
              ElMessage.error(err.message);
            })
          } else {
            done();
          }
        },
      })
        // .then(() => {
        //   deleteData(obj.id);
        // })
        .catch(() => {
          ElMessage("取消删除");
        });
    };
    function deleteData(id) {
      delEntryGuide(id)
        .then((result) => {
          
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // 分页
    const changePagination = (val) => {
      data.pagination = toRaw(val);
      updateList();
    };

    // 打开查看详情 弹窗
    const openContent = (val) => {
      if (val.prop == "description") {
        data.contentdialogTitle = `查看【${val.value.categoryName}--${val.value.title}】详情描述`;
        data.contentVisible = true;
        data.contentDetails = val.value.description;
      }
    };

    //关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
    };

    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      getListData,
      searchFnc,
      updateList,
      addFnc,
      editFnc,
      deleteFnc,
      changePagination,
      closeDialog,
      openContent,
    };
  },
};
</script>
<style scoped>
</style>

